import React, { useState } from 'react';
import { Pressable, Text, StyleSheet } from 'react-native-web';
import { colors, radius, shadows } from '../theme';

export default function Button({ label, onPress, variant = 'primary', size = 'md', icon, style }) {
  const [hovered, setHovered] = useState(false);

  const bgColor = {
    primary: hovered ? colors.primaryHover : colors.primary,
    danger: hovered ? colors.dangerHover : colors.danger,
    ghost: hovered ? colors.surfaceHover : 'transparent',
    success: hovered ? '#34d399' : colors.success,
  }[variant];

  const textColor = variant === 'ghost' ? colors.textSecondary : colors.white;
  const paddingV = size === 'sm' ? 6 : size === 'lg' ? 14 : 10;
  const paddingH = size === 'sm' ? 12 : size === 'lg' ? 24 : 16;
  const fontSize = size === 'sm' ? 12 : size === 'lg' ? 16 : 14;

  return (
    <Pressable
      style={[
        styles.button,
        { backgroundColor: bgColor, paddingVertical: paddingV, paddingHorizontal: paddingH },
        variant === 'ghost' && styles.ghostBorder,
        style,
      ]}
      onPress={onPress}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
    >
      {icon && <Text style={[styles.icon, { fontSize }]}>{icon}</Text>}
      <Text style={[styles.label, { color: textColor, fontSize }]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radius.sm,
    boxShadow: shadows.button,
    cursor: 'pointer',
    transitionDuration: '150ms',
  },
  ghostBorder: {
    borderWidth: 1,
    borderColor: colors.border,
    boxShadow: 'none',
  },
  icon: {
    marginRight: 6,
  },
  label: {
    fontWeight: '600',
  },
});
